 var Models = {
        ErrorObject          : require('ErrorObject'),
        GalleryFilter        : require('GalleryFilter'),
        GalleryPrimaryFilter : require('GalleryPrimaryFilter'),
        GalleryDetails       : require('GalleryDetails'),
        PictureMetaDataItem  : require('PictureMetaDataItem'),
        SearchResultOverview : require('SearchResultOverview'),
        CascadeSetMappings : require('CascadeSetMappings')
 }

 module.exports = Models;